import axios from 'axios';
import { AppSettings,Storage } from '../../configs';
import { authHeader } from '../../helpers/auth-header';
import utilityHelper from '../../helpers/helperUtil'
import {
  START_LOADING,
  STOP_LOADING,
  CLEAR_PO,
  SEARCH_PO_COMPLETED,
  SEARCH_PO_FAIL,
  SEARCH_PO_ORIGINAL,
  UPDATE_NEW_ASSET,
  ERROR_401
}
  from '../actions/actionTypes'
import { resolve } from 'path';
import { reject } from 'q';

export function clearPODetailAction() {
  return function (dispatch) {
    dispatch({
      type: CLEAR_PO
    });
  }
}

export function getPODetailAction(q_po_no, q_tran_no, q_unitCode, actiontype , q_userId, q_sessionNo ,q_userName) {
  //3110008964
  //4120000541
  return function (dispatch) {
    //startLoadingAction()

    dispatch({
      type: START_LOADING
    })
 
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/rrs/GetData`,
        timeout: 60 * 3 * 1000,
        params: {
          poNo: q_po_no,
          tranNo: q_tran_no,
          unitCode: q_unitCode,
          userId: q_userId,
          sessionNo: q_sessionNo,
          userName: q_userName
        }
      })

      promise.then(response => {
        console.log("getPODetailAction(success)")
        onSearchPOCompleted(dispatch, response.data, actiontype)
      }
      ).catch (error=> {
        console.log("getPODetailAction(error)")
        console.log(error ,(error+"").includes('Error: Request failed with status code 401'))

        dispatch({
          type: SEARCH_PO_FAIL
        })

        dispatch({
          type: STOP_LOADING
        })
    })

      return promise
    }
  }


export function getPODetailOriginalAction(poNo, unitCode, userId) {

  return  function (dispatch) {
    dispatch({
      type : START_LOADING
    })

      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/rrs/GetData`,
        params: {
          poNo: poNo,
          unitCode: unitCode,
          userId: userId
        }
      })
      
      promise.then(response => {
        let transaction=response.data

         //console.log("getPODetailOriginalAction")
         //console.log(response);
    

        let isSuccess=response.data.returnData.isSuccess===true
        let returnMessage=response.data.returnData.returnMessage
        
        if (returnMessage.includes('Error: Request failed with status code 401')) {
          returnMessage = 'กรุณา Login ก่อนเข้าใช้งาน'}
        if(isSuccess){
          dispatch({
            type: SEARCH_PO_ORIGINAL,
            po_original: transaction,
          })
        }else{
          dispatch({
            type: SEARCH_PO_FAIL,
            payload: returnMessage
          })
        }
       
        dispatch({
          type : STOP_LOADING
        })

      })
      .catch(error=>{
        dispatch({
          type: STOP_LOADING
        })

        dispatch({
          type: SEARCH_PO_FAIL,
          payload: error.message + 'xxx'
        })

        if(error.message && error.message.indexOf("code 401")!=-1){
          window.emitter.emit("ERROR_401")
        }
        
      })

      return promise
  }
}

export function saveTransactionAction(isSubmit, transaction, userCode, role, status = null, userName , sessionNo) {
  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })
    
    try {
      let poNo = transaction.t_PO_DETAIL.po_contract_no
      let tranNo = transaction.t_PO_DETAIL.transaction_no
      let doc_type = transaction.t_HEADER.doc_type
      let newStatus = 'DRAF'
      let tempTranAttNo = null;

      tempTranAttNo = transaction.temp_trans_att_no;
      
      if (!tranNo || tranNo.length === 0) {
        //ถ้าเป็นรายการสร้างใหม่
        if (doc_type == "BOT") { 
          if (role === "R") {
            //ถ้าเป็น Reviewer
            if (status === "RPA") {
              newStatus = "BCFM";
            } else if (status === "Manualy") {
              newStatus = "MCFM";
            } else {
              if (status === "REJT"){
                newStatus = "REJT"
              }
              else newStatus = (!isSubmit === true) ? 'VERI' : 'WACCEPT' // 'BCFM'
            }
          }
          else {
            //ถ้าเป็น Creator
            newStatus = (!isSubmit == true) ? 'DRAF' : 'WVER'
          }
        }
        else { // notbot
          if (role === "R") {
            //ถ้าเป็น Reviewer
              newStatus = (!isSubmit === true) ? 'VERI' : 'WACCEPT'
          }
          else {
            //ถ้าเป็น Creator
            newStatus = (!isSubmit == true) ? 'DRAF' : 'WVER'
          }
        }
      }
      else { // have transaction no
        //ถ้าเป็นการอัพเดทข้อมูลเดิม 
        if (doc_type == "BOT"){
          if (status === 'ACCEPT' || status === 'DECL' || status === 'REJT'){
            newStatus = status
          }
          else if (role === "R") {
            //ถ้าเป็น Reviewer
            if (status === "RPA") {
              newStatus = "BCFM";
            } else if (status === "Manualy") {
              newStatus = "MCFM";
            } else {
              if (status === "REJT"){
                newStatus = "REJT"
              }
              else newStatus = (!isSubmit === true) ? 'VERI' : 'WACCEPT' // 'BCFM'
            }
          }
          else {
            //ถ้าเป็น Creator
            newStatus = (!isSubmit === true) ? 'DRAF' : 'WVER'
          }
        }
        else { // notbot
          if (status === 'ACCEPT' || status === 'DECL' || status === 'REJT'){
            newStatus = status
          }
          else if (role === "R") {
            //ถ้าเป็น Reviewer
              newStatus = (!isSubmit === true) ? 'VERI' : 'WACCEPT'
          }
          else {
            //ถ้าเป็น Creator
            newStatus = (!isSubmit == true) ? 'DRAF' : 'WVER'
          }
        }
      }
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/RRS/SetData`,
        timeout: 60 * 3 * 1000,
        data: {
          poNo: poNo,
          model: {
            ...transaction,
            t_PO_DETAIL: {
              ...transaction.t_PO_DETAIL,
              status: newStatus
            }
          },
          usercode: userCode  ?? "",
          tranNo: tranNo ?? "",
          sessionNo : sessionNo ?? "",
          userName : userName ?? "",
          tempTranAttNo: tempTranAttNo ?? ""
        }
      })

      promise.then(response => {
        
        console.log("=============getPODetailAction Completed:")
        
        onSearchPOCompleted(dispatch, response.data, "save")
      }).catch(error=>{
        
        console.log("saveTransactionAction error!")
        console.log(error)

        dispatch({
          type: STOP_LOADING
        })
      })

      return promise
    } catch (error) {
      console.log("saveTransactionAction error!")
      console.log(error)

      reject(error)

      dispatch({
        type: STOP_LOADING
      })
    }
  }
}

export function updateVerifyAction(transaction_no,message_to_committee) {
  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })
    try {
     

      let promise = axios({
        headers: authHeader(),
        method: "put",
        url: `${AppSettings.apiUrl}/api/RRS/UpdateMessageCommittee/${transaction_no}`,
        data: {
          message_to_committee: message_to_committee,
        }
      })

      dispatch({
        type: STOP_LOADING
      })

      return promise
    } catch (error) {
      console.log("updateStatusAction error!")
      console.log(error)

      dispatch({
        type: STOP_LOADING
      })
    }
  }
}

const  onSearchPOCompleted =async function (dispatch, data, actiontype) {
  //const role = Storage.getRole()
  
  let po_no = data.t_PO_DETAIL.po_contract_no
  let tran_no = data.t_PO_DETAIL.transaction_no
  let status = data.t_PO_DETAIL.status
  const role = Storage.getRole()
  let viewMode = (role==="C"? data.t_PO_DETAIL.view_creator: data.t_PO_DETAIL.view_reviewer)==="view"?true:false

  //console.log("onSearchPOCompleted.viewMode:", viewMode)
  
  let isSuccess = data.returnData.isSuccess === true
  let returnMessage = data.returnData.returnMessage
  console.log("check attach")
  
  if (isSuccess) {
 
    if (actiontype !== "save") {
      
      let vendorCode = data.t_PO_DETAIL.vendor_code
      if (vendorCode) {
        await axios({
          headers: authHeader(),
          method: "post",
          url: `${AppSettings.apiUrl}/api/wso2/GetVendorInformation`,
          params: {
            vendorNo: vendorCode
          }
        }).then(response => {
          let z47 = response.data

          if (z47) {
            if (z47.lfB1 && z47.lfB1.item && z47.lfB1.item && z47.lfB1.item.length > 0) {
              data.t_PO_DETAIL.pmt_method = z47.lfB1.item[0].zwels;
              data.t_PO_DETAIL.pmt_meth_sup = z47.lfB1.item[0].uzawe;
            }

            if (z47.bankdetail && z47.bankdetail.item && z47.bankdetail.item.length > 0 && data.t_IR_ONE_TIME_VENDOR) {
              data.t_IR_ONE_TIME_VENDOR.ot_bank_account = z47.bankdetail.item[0].bankn;
              data.t_IR_ONE_TIME_VENDOR.ot_bank_name = z47.bankdetail.item[0].banka;
            }
          }
        })
      }
    }

    console.log("SEARCH_PO_COMPLETED:")
    

    dispatch({
      type: SEARCH_PO_COMPLETED,
      transaction: data,
      tran_no: tran_no,
      viewMode:viewMode,
      po_no: po_no,
      status: status,
      uid: utilityHelper.genDateKey(),
      tempAttNo: utilityHelper.genTempAttNo(),
    })
  } else {
    dispatch({
      type: SEARCH_PO_FAIL,
      payload: returnMessage
    })
  }

  dispatch({
    type: STOP_LOADING
  })
}

export function rejectTransactionAction(transaction, Reject_Result, Reject_By,Reject_Option,Reject_Option_Desc) {
  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })

    try {
      let po_contract_no = transaction.t_PO_DETAIL.po_contract_no
      let transaction_no = transaction.t_PO_DETAIL.transaction_no
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/RRS/SetRejectData`,
        data: {
          transaction_no : transaction_no,
          Reject_Result : Reject_Result,
          Reject_By : Reject_By,
          Reject_Option :Reject_Option,
          Reject_Option_Desc : Reject_Option_Desc
        }
      })

      return promise
      
    } catch (error) {
      console.log("rejectTransactionAction error!")
      console.log(error)

      dispatch({
        type: STOP_LOADING
      })
    }
  }
}

export function updateNewAssetAction(assetNew) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_NEW_ASSET,
      payload : assetNew
    })
  }
}

export function updateStatusAction(transaction_no, status, user) {
  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })
    try {
     

      let promise = axios({
        headers: authHeader(),
        method: "put",
        url: `${AppSettings.apiUrl}/api/RRS/UpdateStatus/${transaction_no}`,
        data: {
          status: status,
          user:user
        }
      })

      dispatch({
        type: STOP_LOADING
      })

      return promise
    } catch (error) {
      console.log("updateStatusAction error!")
      console.log(error)

      dispatch({
        type: STOP_LOADING
      })
    }
  }
}


